import { styled } from "@mui/material/styles";

export default styled("div")(({ theme, ownerState }) => {
  const { palette, functions, borders } = theme;
  const { error, success, disabled } = ownerState;

  const { inputColors, grey, white } = palette;
  const { pxToRem } = functions;
  const { borderRadius, borderWidth } = borders;

  const isDark = palette.mode === "dark"; // ✅

  let borderColorValue = inputColors.borderColor.main;
  if (error) borderColorValue = inputColors.error;
  else if (success) borderColorValue = inputColors.success;

  return {
    display: "flex",
    alignItems: "center",
    backgroundColor: disabled ? grey[200] : isDark ? "#2d2d3f" : white.main, // ✅
    border: `${borderWidth[1]} solid`,
    borderRadius: borderRadius.md,
    borderColor: isDark ? "#4a5568" : borderColorValue, // ✅

    "& .MuiInputBase-input": {
      height: pxToRem(20),
      color: isDark ? "#ffffff" : "inherit", // ✅
      "&::placeholder": {
        color: isDark ? "#a0aec0" : undefined, // ✅
        opacity: isDark ? 1 : undefined,
      },
    },
  };
});